export type PhaseType =
  | 'cenova_nabidka'
  | 'koncept'
  | 'prototypovani'
  | 'elektro_konzultace'
  | 'finalni_rozkresleni'
  | 'dokumentace'
  | 'tisk_cnc_laser'
  | 'postprocessing'
  | 'barveni_patina'
  | 'kompletace'
  | 'patina_doladeni'
  | 'foceni'
  | 'export';

// Číselník typů fází v pořadí typického workflow (uživatel přidává ručně).
export const PHASE_TYPE_ORDER: PhaseType[] = [
  'cenova_nabidka',
  'koncept',
  'prototypovani',
  'elektro_konzultace',
  'finalni_rozkresleni',
  'dokumentace',
  'tisk_cnc_laser',
  'postprocessing',
  'barveni_patina',
  'kompletace',
  'patina_doladeni',
  'foceni',
  'export',
];

export const PHASE_TYPE_LABEL: Record<PhaseType, string> = {
  cenova_nabidka: 'Cenová nabídka',
  koncept: 'Koncept',
  prototypovani: 'Prototypování',
  elektro_konzultace: 'Elektro konzultace',
  finalni_rozkresleni: 'Finální rozkreslení',
  dokumentace: 'Dokumentace',
  tisk_cnc_laser: 'Tisk / CNC / laser',
  postprocessing: 'Postprocessing',
  barveni_patina: 'Barvení / patina',
  kompletace: 'Kompletace',
  patina_doladeni: 'Patina – doladění',
  foceni: 'Focení',
  export: 'Export',
};

export type PhaseStatus = 'pending' | 'in_progress' | 'done' | 'skipped' | 'blocked';

export const PHASE_STATUS_META: Record<PhaseStatus, { label: string; badge: string; dot: string }> = {
  pending: { label: 'Čeká', badge: 'bg-zinc-100 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-300', dot: 'bg-zinc-400 dark:bg-zinc-500' },
  in_progress: { label: 'Probíhá', badge: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300', dot: 'bg-amber-500' },
  done: { label: 'Hotovo', badge: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300', dot: 'bg-emerald-500' },
  skipped: { label: 'Přeskočeno', badge: 'bg-zinc-100 text-zinc-500 dark:bg-zinc-800 dark:text-zinc-400 line-through', dot: 'bg-zinc-300 dark:bg-zinc-600' },
  blocked: { label: 'Blokováno', badge: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300', dot: 'bg-red-500' },
};

export interface Phase {
  id: string;
  propItemId: string;
  type: PhaseType;
  orderIndex: number;
  status: PhaseStatus;
  skipReason: string | null;
  blockReason: string | null;
  assignedToUserId: string | null;
  plannedStart: string | null;
  plannedEnd: string | null;
  estimatedMinutes: number | null;
  actualMinutes: number;
  estimatedCost: string | null;
  actualCost: string;
  flatLaborCost: string | null;
  notes: string | null;
  startedAt: string | null;
  completedAt: string | null;
  reopenedAt: string | null;
  reopenReason: string | null;
  reopenCount: number;
  assignedTo: { id: string; fullName: string } | null;
  _count: { timeLogs: number; materialUsages: number; costs: number; knowledgePins?: number; machineBookings?: number; documentPins?: number };
  createdAt: string;
  updatedAt: string;
}
